import React from 'react';
import './Hero.scss';
import { Link } from "react-router-dom";
// Replace with your actual hero photo (women in professional/training context)
const HERO_IMAGE = 'assets/Unfm/pexels-photo-8938273.avif';

const STATS = [
  {
    id: 'centres',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4 21V7l8-4 8 4v14M4 21h16M4 21v-4M20 21v-4M9 21v-6h6v6"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    text: '86 centres de formation, 8 centres CFA, 15 spécialités',
  },
  {
    id: 'formateurs',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M17 20v-1.5a3.5 3.5 0 0 0-3.5-3.5h-5A3.5 3.5 0 0 0 5 18.5V20M12 11.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM19 20v-1.5a3 3 0 0 0-2-2.83M15 4.7a3 3 0 0 1 0 5.6"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    text: 'Plus de 1000 formateurs mobilisés',
  },
  {
    id: 'couverture',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 21s7-6.1 7-11.5A7 7 0 0 0 5 9.5C5 14.9 12 21 12 21Z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="12" cy="9.5" r="2.2" stroke="currentColor" strokeWidth="1.6" />
      </svg>
    ),
    text: 'Couverture dans toutes les régions du Maroc',
  },
];

const UNFMHero = () => {
  return (
    <div className="unfm-hero">
      <section
        className="hero"
        style={{ backgroundImage: `url(${HERO_IMAGE})` }}
      >
        <div className="hero__overlay" />

        <div className="hero__container">
          <div className="hero__content">
            <h1 className="hero__title">
              UNFM 2.0 — Orienter, former, insérer&nbsp;: le parcours des
              femmes vers l&apos;emploi
            </h1>

            <p className="hero__subtitle">
              Une plateforme numérique intégrée qui connecte femmes
              candidates, assistants sociaux, associations et formateurs
              pour simplifier l&apos;orientation et le suivi de la
              formation professionnelle, partout au Maroc.
            </p>

            <div className="hero__actions">
              <Link href="/orientation" className="btn btn--solid">
                Faire ma demande d&apos;orientation
              </Link>
              <Link to="/members/inscription" className="btn btn--outline-light">
                Je suis une association / un formateur
              </Link>
            </div>
          </div>

          <ul className="hero__stats">
            {STATS.map((stat) => (
              <li key={stat.id} className="hero__stat">
                <span className="hero__stat-icon">{stat.icon}</span>
                <span className="hero__stat-text">{stat.text}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
};

export default UNFMHero;